import React from 'react';
import { connect } from 'react-redux';
import { permissionFinder } from '../../helpers/util';
import { Redirect, Route } from 'react-router-dom';
import { loggedAccountType } from '../../helpers/token';
import { userStorage } from 'helpers/user-storage';
import { global } from 'config';

function returnRouteByPermissions(route) {
  if (route) {
    if (route.restrictedAccount) {
      if (route.accountType === route.restrictedAccount) return true;
      else return false;
    }
    else if (route.pccwglobal_only) {
      if (route.accountType < 200 && permissionFinder(route.loggedPermissions, route.accountType, route.restrictedFunction, route.action, route.user)) return true;
      else return false;
    }
    else if (permissionFinder(route.loggedPermissions, route.accountType, route.restrictedFunction, route.action, route.user)) return true
    else return false
  } else return false
}


const CustomerRequiredRoute = ({ component: Component, ...rest }) => (

  <Route exact {...rest} render={props => (
    rest.loggedIn && rest.user && rest.accountType >= 200 && permissionFinder(rest.loggedPermissions, rest.accountType, rest.restrictedFunction, rest.action, rest.user) ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: global.unauthorised || global.logout,
        state: { from: props.location }
      }} />
    )
  )} />
)

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  return {
    loggedIn,
    accountType: loggedAccountType(),
    loggedPermissions: userStorage.getPermissions(),
    user: userStorage.getUser()
  };
}

export default connect(mapStateToProps)(CustomerRequiredRoute);
